<template>
  <div class="WrapperSvgTitleText lxn-w100">
    <div class="WrapperSvgTitleText-wrapper-svg lxn-margin-auto">
      <slot name="svg"></slot>
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="WrapperSvgTitleText-wrapper-title lxn-title lxn-text-center">
      <slot name="title"></slot>
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="WrapperSvgTitleText-wrapper-text lxn-margin-auto lxn-w100 lxn-text lxn-text-justify">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WrapperSvgTitleText',
  components: {
  },
  props: {
  },
  data: function () {
    return {
      window: {
        width: 0,
        height: 0,
        svgComponentWidth: 0,
      }
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .WrapperSvgTitleText {
    margin-bottom: 14px; 
  }
  .WrapperSvgTitleText-wrapper-svg {
    width: 250px;
    height: 250px;
    padding: 20px;
  }
  .WrapperSvgTitleText-wrapper-title {
    margin-top: 20px;
    height: 30px;
    color: #1EA5DE;
    line-height: 30px;
  }
  .WrapperSvgTitleText-wrapper-text {
    width: calc(100% - 36px);
    color: #53636C;
    margin-top: 5px;
    padding-bottom: 14px;
  }
</style>
